const successTitle = 'Buen trabajo';
const errorTitle = 'Opsss';
const warningTitle = 'Atención';

export { successTitle, errorTitle, warningTitle };
